import React from 'react';
import { motion } from 'framer-motion';
import { Search, MapPin, BarChart, Rocket } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Audit & Analysis',
  description: 'We start with a deep dive into your current demand drivers, positioning, traffic patterns, and competitive landscape.',
  icon: Search
}, {
  number: '02',
  title: 'Strategy Design',
  description: 'You receive a custom roadmap for growth and acquisition, grounded in intelligence — not opinion.',
  icon: MapPin
}, {
  number: '03',
  title: 'Implementation',
  description: 'Execution done right: funnels, automation, review systems, analytics, tracking, and optimization frameworks.',
  icon: Rocket
}, {
  number: '04',
  title: 'Optimization',
  description: 'Continuous monitoring and refinement to increase profitability and reduce wasted spend.',
  icon: BarChart
}];
export function Process() {
  return <section id="process" className="py-24 bg-[#0a0a0a] text-white relative overflow-hidden" data-id="element-218">
      {/* Abstract background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-219">
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-blue-600/10 rounded-full blur-[100px]" data-id="element-220" />
        <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-[#ff8a33]/10 rounded-full blur-[100px]" data-id="element-221" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-222">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-223">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-[#ff8a33] text-xs font-semibold uppercase tracking-wider mb-6 backdrop-blur-sm" data-id="element-224">
            How It Works
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-225">
            From Insight to{' '}
            <span className="text-gradient-orange" data-id="element-226">Execution</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-400" data-id="element-227">
            A structured approach to unlocking scalable growth.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-228">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-229" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative group" data-id="element-230">
              <div className="w-24 h-24 mx-auto bg-[#1a1a1a] rounded-2xl border border-white/10 flex items-center justify-center mb-8 relative z-10 group-hover:border-[#ff8a33]/50 transition-colors shadow-lg shadow-black/50" data-id="element-231">
                <step.icon className="w-10 h-10 text-gray-400 group-hover:text-[#ff8a33] transition-colors" data-id="element-232" />
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-[#ff8a33] flex items-center justify-center text-black font-bold text-sm shadow-md" data-id="element-233">
                  {step.number}
                </div>
              </div>

              <div className="text-center px-4" data-id="element-234">
                <h3 className="text-xl font-bold mb-3 text-white group-hover:text-[#ff8a33] transition-colors" data-id="element-235">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-236">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}